@if (component.quickLinks?.length) {
<div class="no-wrap overflow-hidden"
     dragScroll>
    @for (item of component.quickLinks; track $index) {
    <href [hrefClass]="'inline-block bg-col-5 col-12 p2 quick-link'"
          [link]="item.url">{{item.label}}</href>
    }
</div>
}